// Company data - Single source of truth

export const companyInfo = {
  name: "VOITECH SOLUTIONS",
  tagline: "Transforming Technology, Empowering Communities",
  logo: "/img/logo/logo-color.png",
  
  // EXACT - Do not modify
  mission: "To deliver exceptional, reliable technological experiences that transform businesses and communities.",
  
  // EXACT - Do not modify
  vision: "Harness technology to create a connected, informed, secure, and thriving society.",
  
  // EXACT - Do not modify
  values: [
    "Professionalism",
    "Integrity",
    "Dependability",
    "Community",
    "Innovation",
    "Collaboration"
  ],
  
  about: {
    intro: "Voitech Solutions stands at the forefront of ICT innovation in Uganda and across East Africa. We embrace 'Technology as a Service' (TaaS) to deliver comprehensive solutions that empower organizations to achieve their full potential.",
    description: "Our team of seasoned engineers and ICT professionals crafts tailored solutions that address unique business challenges. With over 40 years of combined expertise, we bring deep industry knowledge to every project we undertake.",
    taas: "At Voitech, we believe technology should be accessible, reliable, and transformative. Our TaaS approach ensures businesses receive end-to-end support from strategic planning to implementation and ongoing maintenance—allowing them to focus on what matters most: their core operations."
  },
  
  strengths: [
    "40+ years of combined ICT expertise",
    "Strategic partnerships with globally renowned technology brands",
    "Unwavering commitment to internal quality standards",
    "Reliable and efficient solution delivery",
    "Customer-first approach with dedicated support",
    "Local presence with international best practices"
  ],
  
  // EXACT - Do not modify contact details
  contact: {
    social: {
      facebook: "voitechsolutions",
      linkedin: "company/voitech-solutions/",
      twitter: "@VoitechSolutions"
    },
    address: [
      "Level 1, Maria House, Plot 12 - 13 Kataza Cose, Bugolobi, Kampala – Uganda",
      "P.O. Box 143426 Kampala – Uganda"
    ],
    phones: [
      // "+256 702 200177 | +256 702 696169",
      "+256 323 277300 | +256 200 777300" 
    ],
    email: "sales@voitechsolutions.net",
    website: "www.voitechsolutions.net"
  },
  
  heroQuote: "At Voitech Solutions, we empower communities and organizations to achieve exceptional results through customized technology solutions, delivered with expertise, reliability, and a customer-first approach."
};

export const navigationLinks = [
  { name: "Home", href: "/" },
  { name: "About", href: "/about" },
  { name: "Services", href: "/services" },
  { name: "Products", href: "/products" },
  { name: "Partnerships", href: "/partnerships" },
  { name: "Certifications", href: "/certifications" },
  { name: "Clients", href: "/clients" },
  { name: "Resources", href: "/resources" },
  { name: "Contact", href: "/contact" }
];

export const clientSectors = [
  {
    name: "Commercial & Business",
    icon: "Building2",
    description: "Enterprise solutions for corporate organizations"
  },
  {
    name: "Medical Institutions",
    icon: "Heart",
    description: "Healthcare technology and connectivity solutions"
  },
  {
    name: "Educational Facilities",
    icon: "GraduationCap",
    description: "Smart campus and e-learning infrastructure"
  },
  {
    name: "Residential",
    icon: "Home",
    description: "Home automation and smart living solutions"
  },
  {
    name: "Government Agencies",
    icon: "Landmark",
    description: "Secure government ICT infrastructure"
  },
  {
    name: "Diplomatic Missions",
    icon: "Globe",
    description: "Embassy and consulate technology solutions"
  },
  {
    name: "Telecommunications",
    icon: "Radio",
    description: "Telco infrastructure and network solutions"
  },
  {
    name: "Travel Sector",
    icon: "Plane",
    description: "Hospitality and travel industry technology"
  },
  {
    name: "NGOs",
    icon: "Users",
    description: "Non-profit organization ICT support"
  }
];
